import _ from 'lodash'

import { Select } from '../NarusMaterial/Select'

import {
  makeAutobindedInput,
  makeValidatedInput
} from './FormBuilder'

export const SelectField = props => {
  const {
    onChange,
    onBlur,
    label,
    errorText,
    disabled,
    noSort,
    required,
    validators,
    errors,
    placeholder,
    options: propOptions,
    value: propValue
  } = props

  const getSelectedValueFromOptions = value => {
    const foundOption = (props.options || []).find(item =>
      _.isEqual(item.value || item.code, value))

    if (!foundOption) {
      return 'null'
    }
    const val = _.get(foundOption, 'value', _.get(foundOption, 'code', null))
    return JSON.stringify(val)
  }

  const options = (propOptions || []).map(option => ({
    value: JSON.stringify(option.value || option.code),
    label: option.label,
    level: option.level || 1
  }))

  const handleOnChange = event => {
    if (
      event &&
      event.target &&
      event.target.value &&
      event.target.value !== 'null'
    ) {
      if (onChange) {
        onChange(JSON.parse(event.target.value))
      }
    } else if (onChange) {
      onChange(null)
    }
  }

  return (
    <Select
      noSort={noSort}
      onBlur={onBlur || null}
      label={label}
      errorText={errorText || ''}
      value={getSelectedValueFromOptions(propValue)}
      disabled={disabled || false}
      onChange={handleOnChange}
      data={options}
      required={required}
      validators={validators}
      errors={errors}
      placeholder={placeholder}
    />
  )
}
export const SelectInput = makeAutobindedInput(makeValidatedInput(SelectField))
